export default __webpack_public_path__ + "static/media/kayaguneridort8.4ad52971.jpg";